import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'; 
 


//THREE.DefaultLoadingManager.setCrossOrigin("anonymous");

/**
 * Base
 */
// Debug
const gui = new dat.GUI(); 

let stxt, listener, audioLoader;

// Canvas
const canvas = document.querySelector('canvas.webgl'); 

document.querySelector('#sinput').addEventListener('keyup', function(e) {
    //console.log('Input value changed:', e.target.value);  // Log the changed input value
   // stxt = e.target.value;
    
});


stxt = 'RIP Thanos \n you will be missed'; 

//initialize the mp3s.... 

const audioList = []; // Store audio objects
const audioFiles = [
  'sounds/horror-background.mp3',
  'sounds/horror-halloween.mp3',
  'sounds/wind-blowing.mp3'
]; 

 

// Scene
const scene = new THREE.Scene(); 

 



// Fog 
const fog = new THREE.Fog('#262837', 1, 15);  //
scene.fog = fog;

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader(); 
textureLoader.crossOrigin = "anonymous"; // Correct way to set crossOrigin

//door textures...
const doorColorTexture = textureLoader.load('textures/door/color.jpg');
const doorAlphaTexture = textureLoader.load('textures/door/alpha.jpg'); 
const doorAmbientOcclusionTexture = textureLoader.load('textures/door/ambientOcclusion.jpg'); 
const doorHeightTexture = textureLoader.load('textures/door/height.jpg'); 
const doorNormalTexture = textureLoader.load('textures/door/normal.jpg'); 
const doorMetalnessTexture = textureLoader.load('textures/door/metalness.jpg'); 
const doorRoughnessTexture = textureLoader.load('textures/door/roughness.jpg'); 

//bricks textures...
const bricksColorTexture = textureLoader.load('textures/bricks/color.jpg');
const bricksAmbientOcclusionTexture = textureLoader.load('textures/bricks/ambientOcclusion.jpg');
const bricksNormalTexture = textureLoader.load('textures/bricks/normal.jpg');
const bricksRoughnessTexture = textureLoader.load('textures/bricks/roughness.jpg');

//grass textures...
const grassColorTexture = textureLoader.load('textures/grass/color.jpg');
const grassAmbientOcclusionTexture = textureLoader.load('textures/grass/ambientOcclusion.jpg');
const grassNormalTexture = textureLoader.load('textures/grass/normal.jpg');
const grassRoughnessTexture = textureLoader.load('textures/grass/roughness.jpg');


//to reduce the big grass textures and make them repeat 
grassColorTexture.repeat.set(8, 8);
grassAmbientOcclusionTexture.repeat.set(8, 8); 
grassNormalTexture.repeat.set(8, 8);
grassRoughnessTexture.repeat.set(8, 8);

grassColorTexture.wrapS = THREE.RepeatWrapping;
grassAmbientOcclusionTexture.wrapS = THREE.RepeatWrapping;
grassNormalTexture.wrapS = THREE.RepeatWrapping; 
grassRoughnessTexture.wrapS = THREE.RepeatWrapping; 

grassColorTexture.wrapT = THREE.RepeatWrapping;
grassAmbientOcclusionTexture.wrapT = THREE.RepeatWrapping;
grassNormalTexture.wrapT = THREE.RepeatWrapping; 
grassRoughnessTexture.wrapT = THREE.RepeatWrapping; 




/**
 * House
 */

const house = new THREE.Group(); 
scene.add(house);

// Walls
const walls = new THREE.Mesh(
    new THREE.BoxGeometry(4, 2.5, 4),  //width, height, depth
    new THREE.MeshStandardMaterial({ 
       // color: '#ac8e82' 
         map: bricksColorTexture,
         aoMap: bricksAmbientOcclusionTexture,
         normalMap: bricksNormalTexture, 
         roughnessMap: bricksRoughnessTexture

    })   //for a realistic look with lights...
)

walls.geometry.setAttribute(
    'uv2', 
    new THREE.Float32BufferAttribute(walls.geometry.attributes.uv.array, 2)  //uv-2d coords, (2)
); 

walls.position.y = 2.5 / 2; // move the walls up. 
//because half the walls is under the ground... 
house.add(walls);

walls.receiveShadow = true;


// Roof - is a pyramid....  so we use a cone and change the segments to 4 to get a pyramid.. 
const roof = new THREE.Mesh(
    new THREE.ConeGeometry(3.5, 1, 4), //radius, height, segments 
    new THREE.MeshStandardMaterial({ color: '#b35f45' })
); 

house.add(roof);
roof.castShadow = true;
roof.rotation.y = Math.PI/4;

//to keep the roof ontop the house. and move it up. 
roof.position.y = 2.5 + 0.5;  //0.5 = half the height of the cone.. 1 unit / 2. 


// Door  
const door = new THREE.Mesh(
    new THREE.PlaneGeometry(2.2, 2,2, 100, 100), //to make the displacement map work.. - add vertices. 
    new THREE.MeshStandardMaterial({
         //color: '#aa7b7b' 
         map: doorColorTexture, //the door texture... 
         transparent: true,  // to make the door transparent... 
         alphaMap: doorAlphaTexture,  //removes the black part, 
         aoMap: doorAmbientOcclusionTexture, //you provide uv2 attributes for the ambiantocclusion map... 
         displacementMap: doorHeightTexture, //displacement map...
         // wireframe: true,
         displacementScale: 0.1,  //how much the displacement map should affect the geometry.
         normalMap: doorNormalTexture,
         metalnessMap: doorMetalnessTexture,
         roughnessMap: doorRoughnessTexture
    })    
); 
house.add(door); 

//to make the aoMap visible... 
//to provide uv2 attributes for the ambiantocclusion map...
door.geometry.setAttribute(
    'uv2', 
    new THREE.Float32BufferAttribute(door.geometry.attributes.uv.array, 2)  //uv-2d coords, (2)
); 

//move the door forward.. 
door.position.z = 2 + 0.01; //0.01 to avoid z-fighting.
door.position.y = 1; //half the height of the door.


// Bushes 
const bushGeometry = new THREE.SphereGeometry(1, 16, 16); //radius, widthSegments, heightSegments
const bushMaterial = new THREE.MeshStandardMaterial({ color: '#89c854' }); 

//create each bushes... 
const bush1 = new THREE.Mesh(bushGeometry, bushMaterial);
bush1.scale.set(0.5, 0.5, 0.5); 
bush1.position.set(0.8, 0.2, 2.2); 

bush1.receiveShadow = true; 
bush1.castShadow = true;

//create each bushes... 
const bush2 = new THREE.Mesh(bushGeometry, bushMaterial);
bush2.scale.set(0.25, 0.25, 0.25); 
bush2.position.set(1.4, 0.1, 2.1); 
bush2.receiveShadow = true; 
bush2.castShadow = true;

//create each bushes... 
const bush3 = new THREE.Mesh(bushGeometry, bushMaterial);
bush3.scale.set(0.4, 0.4, 0.4); 
bush3.position.set(-0.8, 0.1, 2.2); 
bush3.receiveShadow = true; 
bush3.castShadow = true;

//create each bushes... 
const bush4 = new THREE.Mesh(bushGeometry, bushMaterial);
bush4.scale.set(0.15, 0.15, 0.15); 
bush4.position.set(-1, 0.05, 2.6); 
bush4.receiveShadow = true; 
bush4.castShadow = true;

house.add(bush1, bush2, bush3, bush4);

// Graves 
const graves = new THREE.Group(); 
scene.add(graves); 


//console.log('value', sInptObj.value);


const graveGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.2); //width, height, depth
const graveMaterial = new THREE.MeshStandardMaterial({ color: '#b2b6b1' /*, wireframe: true */  });


 
for(let i = 0; i < 50; i++){
    const angle = Math.random() * Math.PI * 2;  //360 degrees
    //create a new radius.... 
    const radius = 3 + Math.random() * 6;  //3 + random number between 0 and 6.

    //positioned on the x and on the z axis....  not on the y axis.... 
    const _x = Math.sin(angle) * radius; 
    const _z = Math.cos(angle) * radius; 

    //create the grave meshs... 
    const grave = new THREE.Group();  //container for the grave... 
    const grv = new THREE.Mesh(graveGeometry, graveMaterial);
    grave.add(grv);

    //create a graveTxtStone 
    const tombStone = new THREE.Mesh(
        new THREE.PlaneGeometry(0.6, 0.4),
        new THREE.MeshStandardMaterial({ 
            /*color: 0xff0000,  })/*/
            map: createTextTexture(stxt), //'RIP Thanos \n you will be missed'), 
            transparent: true 
        })
    );
    tombStone.position.set(0, 0.2, 0.11);
    grave.add(tombStone);
    
    grave.position.set(_x, 0.3, _z); //y = 0. 
    grave.rotation.y = (Math.random() - 0.5) * 0.4;  //(from 0.5 to 0.5) //random rotation on the y axis.
    grave.rotation.z = (Math.random() - 0.5) * 0.4;  //(from 0.5 to 0.5) //random rotation on the y axis.
    grave.castShadow = true; 
    grave.receiveShadow = true;


    graves.add(grave);

}





// Floor
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(20, 20), 
    new THREE.MeshStandardMaterial({ 
        //color: '#a9c388', 
        map:grassColorTexture, 
        aoMap: grassAmbientOcclusionTexture, 
        normalMap: grassNormalTexture, 
        roughnessMap: grassRoughnessTexture,
        side:THREE.DoubleSide 
    })
); 

floor.geometry.setAttribute(
    'uv2', 
    new THREE.Float32BufferAttribute(floor.geometry.attributes.uv.array, 2)  //uv-2d coords, (2)
); 

 
floor.rotation.x = - Math.PI * 0.5
floor.position.y = 0

floor.receiveShadow = true;

scene.add(floor)

/**
 * Lights
 */
// Ambient light
const ambientLight = new THREE.AmbientLight('#b9d5ff', 0.12); //like the moon light.. 
gui.add(ambientLight, 'intensity').min(0).max(1).step(0.001)
scene.add(ambientLight)

// Directional light
const moonLight = new THREE.DirectionalLight('#b9d5ff', 0.12)
moonLight.position.set(4, 5, - 2)
gui.add(moonLight, 'intensity').min(0).max(1).step(0.001)
gui.add(moonLight.position, 'x').min(- 5).max(5).step(0.001)
gui.add(moonLight.position, 'y').min(- 5).max(5).step(0.001)
gui.add(moonLight.position, 'z').min(- 5).max(5).step(0.001)
scene.add(moonLight)

// Door light
const doorLight = new THREE.PointLight('#ff7d46', 1, 7); 
doorLight.position.set(0, 2.2, 2.7);  //at the top of the door.....
house.add(doorLight);  

// ghosts 1
const ghost1 = new THREE.PointLight('#ff00ff', 2, 3);
ghost1.castShadow = true; 
scene.add(ghost1);
 
const ghost2 = new THREE.PointLight('#00ffff', 2, 3);
ghost2.castShadow = true; 
scene.add(ghost2);
 
const ghost3 = new THREE.PointLight('#ffff00', 2, 3);
ghost3.castShadow = true; 
scene.add(ghost3);


//optimize the shadows by controlling the mapsize.... 
doorLight.shadow.mapSize.width = 256;
doorLight.shadow.mapSize.height = 256;  //smaller size, better performance.
doorLight.shadow.camera.far = 7;  //far distance of the shadow camera.
doorLight.shadow.camera.near = 0.1;  //near distance of the shadow camera.

//optimize the shadows by controlling the mapsize.... 
ghost1.shadow.mapSize.width = 256;
ghost1.shadow.mapSize.height = 256;  //smaller size, better performance.
ghost1.shadow.camera.far = 7;  //far distance of the shadow camera.
ghost1.shadow.camera.near = 0.1;  //near distance of the shadow camera.

//optimize the shadows by controlling the mapsize.... 
ghost2.shadow.mapSize.width = 256;
ghost2.shadow.mapSize.height = 256;  //smaller size, better performance.
ghost2.shadow.camera.far = 7;  //far distance of the shadow camera.
ghost2.shadow.camera.near = 0.1;  //near distance of the shadow camera.

//optimize the shadows by controlling the mapsize.... 
ghost3.shadow.mapSize.width = 256;
ghost3.shadow.mapSize.height = 256;  //smaller size, better performance.
ghost3.shadow.camera.far = 7;  //far distance of the shadow camera.
ghost3.shadow.camera.near = 0.1;  //near distance of the shadow camera.


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 4
camera.position.y = 2
camera.position.z = 5
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})



//load the audio files...

// audioLoader = new THREE.AudioLoader();
// loadMultipleAudioFiles(audioFiles);



renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor('#262837'); //make the background... the same color as the fog...
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap; //better shadows...
/**
 * Animate
*/


const updateGhosts = (t) => {
    t *= 0.5;
    ghost1.position.x = Math.cos(t)  * 4;
    ghost1.position.z = Math.sin(t)  * 4;
    ghost1.position.y = Math.sin(t  * 3);

    let t2 = t * -0.32;  // slower
    ghost2.position.x = Math.cos(t2)  * 5;
    ghost2.position.z = Math.sin(t2)  * 5;
    ghost2.position.y = Math.sin(t  * 4) + Math.sin(t  * 2.5);

    let t3 = t * -0.18;
    ghost3.position.x = Math.cos(t3)  * (7 + Math.sin(t  * 0.32));
    ghost3.position.z = Math.sin(t3)   * (7 + Math.sin(t  * 0.32));
    ghost3.position.y = Math.sin(t3  * 2) + (7 + Math.sin(t  * 0.2));;
}


const clock = new THREE.Clock()

const tick = () => {

    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update(); 

    //update Ghosts... 
    updateGhosts(elapsedTime); 

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick(); 






// //creqte the canvas texture... 
// function createTextTexture(text) {
//     // Create a temporary canvas to measure text width
//     const tempCanvas = document.createElement('canvas');
//     const tempContext = tempCanvas.getContext('2d');
    
//     // Set font style for measurement
//     const fontSize = 34;
//     tempContext.font = `${fontSize}px Arial`;
    
//     // Measure the text width
//     const textWidth = tempContext.measureText(text).width;
  
//     // Determine canvas size (padding added for margins)
//     const canvasSize = Math.max(textWidth + 20, 256); // Minimum size 256x256
//     const canvas = document.createElement('canvas');
//     canvas.width = canvasSize;
//     canvas.height = canvasSize;
  
//     // Draw the text on the final canvas
//     const context = canvas.getContext('2d');
//     context.fillStyle = '#000'; // Background color
//     context.fillRect(0, 0, canvas.width, canvas.height);
//     context.fillStyle = '#000'; // Text color
//     context.font = `${fontSize}px Arial`;
//     context.textAlign = 'center';
//     context.textBaseline = 'middle';
  
//     // Draw text in the center of the canvas
//     context.fillText(text, canvas.width / 2, canvas.height / 2);
  
//     // Return the texture
//     return new THREE.CanvasTexture(canvas);
//   }

  function createTextTexture(text, fontSize = 40, lineHeight = 30) {
    const lines = text.split('\n'); // Split text into lines based on newline character
  
    // Determine canvas dimensions based on the number of lines and font size
    const canvasWidth = 512;
    const canvasHeight = Math.max(lines.length * lineHeight + 20, 256); // Add padding
  
    const canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
  
    const context = canvas.getContext('2d');
    // Clear canvas for a transparent background
     context.clearRect(0, 0, canvas.width, canvas.height);
  
    // Draw background
    //context.fillStyle = '#000'; // Background color
    //context.fillRect(0, 0, canvas.width, canvas.height);
  
    // Draw text
    context.fillStyle = '#000000'; // Text color
    context.font = `bold ${fontSize}px Arial`;
    context.textAlign = 'center';
    context.textBaseline = 'top';
  
    // Draw each line of text
    lines.forEach((line, index) => {
        console.log(index);
      let ypos = index * lineHeight + (index == 0 ? 30 : 40);
      context.fillText(line, canvas.width / 2, ypos);
    });
  
    return new THREE.CanvasTexture(canvas);
  }
  
  

//   //function to load multiple audio files... 
//   function loadMultipleAudioFiles(files, cameras) {
//     let loadedCount = 0;
  
//     files.forEach((file, index) => {

//       const audio = new THREE.AudioListener(); 
//       camera.add(audio);
  
//       audioLoader.load(file, (buffer) => {
//           audio.setBuffer(buffer);
//           audio.setLoop(true);
//           audio.setVolume(0.5);
          
//           audioList.push(audio);

//           audio.play();  //play the audio...


//           loadedCount++;
//           if (loadedCount === files.length) { // Play all audio once all are loaded
//             playAllAudio();
//           }
//         },
//         undefined,
//         (error) => {
//           console.error(`Error loading audio file: ${file}`, error);
//         }
//       );
   
//     });
//   }

//   function playAllAudio() {
//     audioList.forEach((audio) => {
//       audio.play();
//     });
//   }




  // Create AudioContext
const audioContext = new (window.AudioContext || window.webkitAudioContext)();

// Load MP3 File Manually
function loadAudioFile(url) {
  fetch(url)
    .then(response => response.arrayBuffer()) // Load the file as ArrayBuffer
    .then(arrayBuffer => audioContext.decodeAudioData(arrayBuffer)) // Decode the audio data
    .then(audioBuffer => {
      // Create a buffer source
      const audioSource = audioContext.createBufferSource();
      audioSource.buffer = audioBuffer;

       // Create a GainNode to control volume
       const gainNode = audioContext.createGain();
       gainNode.gain.value = 0.2; // Set volume (0.0 to 1.0)
 
       // Connect the nodes: audioSource -> gainNode -> destination
       audioSource.connect(gainNode);
       gainNode.connect(audioContext.destination);

      // Enable looping
      audioSource.loop = true;

      // Connect the source to the audio context destination (speakers)
      audioSource.connect(audioContext.destination);

      // Start playing the audio
      audioSource.start(0);
      console.log("Audio playing...");
    })
    .catch(error => console.error('Error loading audio file:', error));
}

 
loadAudioFile(audioFiles[1]); // Replace with your MP3 file path